import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  .loading-wrap,
  .err-wrap {
    min-height: calc(100vh - 350px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    .mid-info-text {
      padding: 10px 0 25px 0;
    }
  }

  .final-button-wrap {
    display: flex;
    width: 100%;
    justify-content: center;
  }
`;

export const ContentWrapSC = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
